document.addEventListener("click", (e) => {
  if (!e.target.closest("[data-mobile-search-toggle]")) return;

  document.dispatchEvent(new CustomEvent("mobile-search:open"));
});
